import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { SlideNavigationService } from './slide-navigation.service';
import { UserDataService } from '../auth/user.data.service';
import { AuthClient } from '../auth/auth.client';
import { Store } from '@ngrx/store';
import { ActivatedRoute, Router, RoutesRecognized } from '@angular/router';
import { RestApi } from 'app/auth/rest.api';
import { ConfigActions } from '../core/reducers/config.actions';
import { Subscription } from 'rxjs';
import { menus } from '../core/models/constants';
import { NavigationService } from '../core/services/navigation.service';
import { IAppState } from 'app/IAppState';
import { IConfigState } from 'app/core/typings/IConfigState';
import { AppDataService } from 'app/app.data.service';
import { I18nService } from 'i18n/i18n.service';
import { BzgModalService } from 'bz-genome-angular';
import { ResetConfirmationComponent } from 'app/shared/components/reset-confirmation/reset-confirmation.component';
import { TimezoneService } from 'app/timezone/services/timezone.service';
import { ITimeZoneList } from 'app/timezone/interfaces/ITimeZoneList';


@Component({
  selector: 'slide-navigation',
  templateUrl: 'slide-navigation.component.html',
  styleUrls: ['slide-navigation.component.scss']
})
export class SlideNavigationComponent implements OnInit {

  public profile: IUserProfile = {};
  public isAutoLoginAuthentication: boolean;
  public currentEnvironment: string;
  public currentEnvironmentDisplayText: string;
  public menuItems: Array<INavItem>;
  public defaultView: string;
  public serverTime: string = 'Local';
  public iconEnvironment: string;
  public viewConfig: IConfigState;
  public currentViewSubscription: Subscription;
  public mcVersion: string;
  public messageLocalTime: string;
  public placeHolderServerTime: string = 'UTC';
  private _currentView: any;
  private _menusSubscription: Subscription;

  private _studioAlertViews = [
    'Security',
    'Ldap',
    'UserGroups',
    'WorkingTimeSchema',
    'Interfaces',
    'Connectors',
    'ECM',
    'Tracing'].map((e => menus[e].title));

  public listTimezone: ITimeZoneList[];
  public currentTimeZone: ITimeZoneList;
  public intervalId: any;
  _showServerTime: boolean = false;

  @ViewChild('selectServerTime') selectServerTime: any;

  @Output() itemNavigationClicked: EventEmitter<void> = new EventEmitter<void>();

  constructor(private _slideNavigationService: SlideNavigationService,
    private _authClient: AuthClient,
    public timeZoneService: TimezoneService,
    private _store: Store<IAppState>,
    private _router: Router,
    private _route: ActivatedRoute,
    private _configActions: ConfigActions,
    private _navigationService: NavigationService,
    private _api: RestApi,
    private _appDataService: AppDataService,
    private _i18nService: I18nService,
    private _timezoneService: TimezoneService,
    private _modalService: BzgModalService) {
    this.serverTime = sessionStorage.getItem('serverTime') ? sessionStorage.getItem('serverTime') : 'UTC';
    this.placeHolderServerTime = this._i18nService.instant('GLOBAL.SERVER_TIME_' + this.serverTime.toUpperCase());
    this._authClient.getAuthenticationTypeResponse().subscribe((data) => {
      this.isAutoLoginAuthentication = data.SubTypeOAuth2Authentication.localeCompare('AutoLogin') === 0 ||
        data.TypeIDPAuthentication.localeCompare('AutoLogin') === 0;
      this.currentEnvironment = sessionStorage.getItem('environmentType');
      if (this.currentEnvironment)
        this.setIcons();
      else
        this.getEnvironment();
    });
    this._api.get('api/version').subscribe((data) => {
      this.mcVersion = data.version;
    });
  };

  ngOnInit() {
    this._store
      .select((s) => s.profile)
      .subscribe((profile: IUserProfile) => {
        this.profile = profile || {};
      });
    this.currentViewSubscription = this._store
      .select((s) => s.config)
      .subscribe((config: IConfigState) => {
        this.viewConfig = config;
      });
    this._router.events
      .subscribe((data) => {
        if (data instanceof RoutesRecognized) {
          if (data.url === '/' && this.defaultView) {
            this.navigateDefaultView();
          } else {
            this._currentView = data.state.root.firstChild.firstChild &&
              data.state.root.firstChild.firstChild.data ? (data.state.root.firstChild.firstChild.data.title as any) : '';
            this._configActions.updateCurrentView(this._currentView);
            this._configActions.updateCurrentMenu(data.state.root.firstChild.routeConfig.path);
          }
        }
      });
    this._menusSubscription = this._navigationService.mainMenuNavItems.subscribe(navItems => {
      if (!this.menuItems || !this.menuItems.length) {
        this.menuItems = navItems;
        if (this.menuItems.length && this.menuItems[0].SubItems.length) {
          this.defaultView = menus[this.menuItems[0].SubItems[0].Name].path;
        }
      }
    });
    this._timezoneService.showServerTime().subscribe((data) => {
      this._showServerTime = data;
    });
    this.getTimeZonesList();
    sessionStorage.setItem('realoadView', 'false');
    this.startSessionObserver();
  }

  ngOnDestroy() {
    this.stopSessionObserver();
    if (this._menusSubscription) {
      this._menusSubscription.unsubscribe();
    }
  }

  startSessionObserver() {
    this.intervalId = setInterval(() => {
      const sessionValue = sessionStorage.getItem('realoadView');
      if (sessionValue === 'true') {
        this.getCurrentEnvironmentTimeZone(true);
        sessionStorage.setItem('realoadView', 'false');
      }
    }, 1000); // Ejecutar cada segundo
  }

  stopSessionObserver() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  getTimeZonesList() {
    this.timeZoneService.getTimeZonesList().subscribe((response) => {
      if (response) {
        this.listTimezone = response;
        this.getCurrentEnvironmentTimeZone();
      }
      else
        this.listTimezone = [];
    });
  }

  getCurrentTimeZoneUser(reload = false) {
    this.timeZoneService.getUserTimeZone().subscribe((response) => {
      this.serverTime = response;
      this.placeHolderServerTime = this._i18nService.instant('GLOBAL.SERVER_TIME_' + this.serverTime.toUpperCase());
      if (this.serverTime === 'UTC') {
        sessionStorage.setItem('serverTimeDifference', `UTC+00:00`);
        sessionStorage.setItem('serverTime', 'UTC');
      }
      if (this.serverTime === 'Business') {
        const timeZoneEnvironment = this.listTimezone.find(itemTimezone => itemTimezone.Id === this.currentTimeZone.Id);
        this.messageLocalTime = timeZoneEnvironment.DisplayName;
        sessionStorage.setItem('serverTimeDifference', `UTC${timeZoneEnvironment.TimeZoneOffset}`);
        sessionStorage.setItem('serverTime', 'Business');
      }

      if (this.serverTime === 'Local') {
        const timeZoneRegion = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const currentDate = new Date();

        //se toma esta fecha para ignorar el horario de verano
        const winterDate = new Date(Date.UTC(currentDate.getFullYear(), 0, 1)); // 1 de enero
        const offsetMinutes = winterDate.getTimezoneOffset();

        const offsetHours = Math.floor(Math.abs(offsetMinutes) / 60);
        const offsetMins = Math.abs(offsetMinutes) % 60;
        const offsetString = `${offsetMinutes <= 0 ? '+' : '-'}${String(offsetHours).padStart(2, '0')}:${String(offsetMins).padStart(2, '0')}`;
        const sameTimeZoneItems = this.listTimezone.filter(itemTimezone => itemTimezone.TimeZoneOffset === offsetString);

        const indexElement = timeZoneRegion.indexOf('/');
        const timeZoneRegionSpecific = timeZoneRegion.substring(indexElement + 1);
        const itemsRegionAndTimeZone = sameTimeZoneItems.filter(itemTimezone => itemTimezone.DisplayName.includes(timeZoneRegionSpecific));

        if (itemsRegionAndTimeZone.length > 0)
          this.messageLocalTime = itemsRegionAndTimeZone[0].DisplayName;
        else
          this.messageLocalTime = `UTC${offsetString} ${timeZoneRegion}`;

        sessionStorage.setItem('serverTimeDifference', `UTC${offsetString}`);
        sessionStorage.setItem('serverTime', 'Local');
      }
      if (reload)
        this.reloadCurrentView();
    });
  }

  getCurrentEnvironmentTimeZone(reload = false) {
    this.timeZoneService.getTimeZoneConfiguration().subscribe((response) => {
      if (response) {
        this.currentTimeZone = response;
        this.getCurrentTimeZoneUser(reload);
      }
      else
        this.currentTimeZone = null;
    });
  }

  onClickNavItem(navItem): void {
    navItem.previousNavItem = this._slideNavigationService.currentNavItem ? { ...this._slideNavigationService.currentNavItem } : null;
    this._slideNavigationService.currentNavItem$.next(navItem);
    this._slideNavigationService.currentNavItem = navItem;
    this.itemNavigationClicked.emit();
  }
  logout() {
    this._authClient.logout();
  }

  getEnvironment() {
    this._appDataService.getCurrentEnvironment().subscribe(environment => {
      sessionStorage.setItem('environmentType', environment.Current);
      this.currentEnvironment = environment.Current;
      this.setIcons();
    });
  }

  setIcons() {
    switch (this.currentEnvironment) {
      case 'Development':
        this.iconEnvironment = 'icon-code';
        this.currentEnvironmentDisplayText = 'GLOBAL.DEVELOPMENT_ENVIRONMENT';
        break;

      case 'Test':
        this.iconEnvironment = 'icon-test';
        this.currentEnvironmentDisplayText = 'GLOBAL.TEST_ENVIRONMENT';
        break;

      case 'Production':
        this.iconEnvironment = 'icon-production';
        this.currentEnvironmentDisplayText = 'GLOBAL.PRODUCTION_ENVIRONMENT';
        break;

      default:
        break;
    }
  }

  reloadCurrentView() {
    const currentRoute = this._router.url;
    let parentPath = currentRoute.indexOf('/settings/') > -1 ? 'settings' : 'mc';
    this._router.navigateByUrl(`/${parentPath}/Refresh`, { skipLocationChange: true }).then(() => {
      this._router.navigateByUrl(currentRoute);
    });
  }

  showStudioAlert() {
    return this.currentEnvironment === 'Development' && _.includes(this._studioAlertViews, this.viewConfig.currentView);
  }

  navigateDefaultView() {
    this._router.navigate(['mc', this.defaultView]);
  }

  changeServerTime(timeZone: string) {
    this.serverTime = timeZone;
    this.placeHolderServerTime = this._i18nService.instant('GLOBAL.SERVER_TIME_' + this.serverTime.toUpperCase());

    let optionTimeZone = 0;
    if (this.serverTime === 'UTC') {
      optionTimeZone = 0;
      sessionStorage.setItem('serverTime', 'UTC');
    }
    if (this.serverTime === 'Local') {
      optionTimeZone = 1;
      sessionStorage.setItem('serverTime', 'Local');
    }
    if (this.serverTime === 'Business') {
      optionTimeZone = 2;
      sessionStorage.setItem('serverTime', 'Business');
    }
    this.timeZoneService.saveUserTimeZone(optionTimeZone).subscribe(() => {
      this.getCurrentEnvironmentTimeZone(true);
    });

  }

  getServerTimeOption(): string | null {
    const serverTime = sessionStorage.getItem('serverTime');
    return serverTime ? serverTime : null;
  }

  resetApp(timeZone: string) {
    if (timeZone !== this.getServerTimeOption()) {
      const title = this._i18nService.instant('GLOBAL.RELOAD_REQUIRED');
      const message = this._i18nService.instant('GLOBAL.RELOAD_MESSAGE');
      const modal = this._modalService.open(ResetConfirmationComponent, {
        closeOnBackdropClick: false,
        closeOnRouterNavigation: true,
        data: { title, message, button: 'GLOBAL.RELOAD' }
      });
      modal.afterClosed().subscribe((result) => {
        if (result === 'reset') {
          this.changeServerTime(timeZone);
        } else {
          this.selectServerTime.value = this.serverTime;
        }
      });
    }
  }
}
